import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import axiosInstance from "../../utils/axiosInstance";
import axiosInstance from "../../../utils/axiosInstance";

export const mfdApi = createAsyncThunk(
  "mfd",
  async ({ startDate = null, endDate = null }) => {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    const response = await axiosInstance.get("/mutualFund", { params });
    return response.data;
  }
);

const mfdSlice = createSlice({
  name: "mfd",
  initialState: {
    mfd: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(mfdApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(mfdApi.fulfilled, (state, action) => {
        state.mfd = action.payload;
        state.loading = false;
      })
      .addCase(mfdApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default mfdSlice.reducer;
